<!--<header class="header-top">
  <div class="header-name1">
    <a [routerLink]='["/"]' (click)='collapse()'>
      South Essex
    </a>
  </div>
  <div class="header-name2"><h6>Registry of deeds</h6></div>
</header>-->

<header>
  <!--<img class="logo" src="images/NHSeal.png" style="opacity:0.7;filter:alpha(opacity=70);" />-->
  <h2><!--<a class="clearfix" >Carroll County New Hampshire <br /><span>Registry of Deeds<br />Home</span></a>--></h2>
  <h2><a class="clearfix" href="https://www.carrollcountynhdeeds.gov/">Carroll County New Hampshire <br /><span>Registry of Deeds<br />Home</span></a></h2>
  <label *ngIf="service.showLogin" class="login"><a href="javascript:;" (click)="getCredentials()">{{service.loginLink}}</a></label>
  <!--<img tabindex="0" title="Shopping Basket" class="basket-img" src="images/basket.png" data-toggle="modal" data-target="#openBasket" (click)="getBasket()">-->

  
    <!--<a href="javascript:;" (click)="getBasket()" class="basket-img"><img alt="Shopping Basket" class="basket-img" src="images/basket.png"></a>-->

<!--        <a (click)="getBasket()">
          <p style="font-size: 35px;">&nbsp;</p>
          <span class="basket-count">{{basketItems.length}}</span>
            <img src="images/basket.png" title="Shopping Basket" style="width: 35px; height: 35px;float:right; top:-35px; background-color:white; position:relative; z-index:0" />
        </a>-->
  <!--<div class="basket">-->
     <!--<app-doc-basket-ex (loaderEvent)="receiveLoader($event)"></app-doc-basket-ex>-->
 <!-- </div>-->

  <div *ngIf="service.isLoggedIn">
    <button mat-icon-button [matMenuTriggerFor]="menu" class="menu">
      <mat-icon class="white-icon">more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu" yPosition="below" backdrop>
      <button mat-menu-item (click)="menuClick(1)">
        <mat-icon>arrow_downward</mat-icon>
        <span>Download Account Statement</span>
      </button>
      <button mat-menu-item (click)="menuClick(2)">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  </div>

    <div class="header-overlay"></div>
</header>



